/**
 * A label for this browser, sent with every batch of changes so the server's operation journal
 * can say which device a change came from. Not a secret and not an identity: clearing site data
 * simply gives the browser a new one.
 */
const KEY = "ledger:device-id";

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = `web-${crypto.randomUUID().slice(0, 8)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "web-unknown"; // storage blocked: the label is only informational
  }
}
